// CountUp Components
export const CountUp = (() => {
	const defaults = {
		selector: ".key-metric__number",
		startAttr: "data-count-start",
		endAttr: "data-count-end",
		durationAttr: "data-count-duration",
		threshold: 0.2,
		once: true,
		locale: null, // null → auto depuis <html lang="">
		decimals: 0,
		valueClass: "value",
		unitClass: "unit",
		initWithStart: true, // si true → affiche la valeur de départ au chargement
	};

	// Fonction pour extraire le nombre + unité
	const parseValue = (val) => {
		const match = /^([\d.,]+)(.*)$/.exec(val.trim());
		return {
			number: parseFloat(match?.[1].replace(",", ".")) || 0,
			unit: match?.[2] || "",
		};
	};

	// Prépare la structure fixe (value + unit)
	const prepareElement = (el, config) => {
		if (el.querySelector(`.${config.valueClass}`)) return;

		const startRaw = el.getAttribute(config.startAttr) || "0";
		const endRaw = el.getAttribute(config.endAttr) || "0";

		const startParsed = parseValue(startRaw);
		const endParsed = parseValue(endRaw);

		const unit = endParsed.unit || startParsed.unit;
		const lang = config.locale || document.documentElement.lang || "en-US";
		const formatter = new Intl.NumberFormat(lang, {
			minimumFractionDigits: config.decimals,
			maximumFractionDigits: config.decimals,
		});

		// Création des spans
		const valueSpan = document.createElement("span");
		valueSpan.className = config.valueClass;
		valueSpan.textContent = config.initWithStart ? formatter.format(startParsed.number) : "0";

		const unitSpan = document.createElement("span");
		unitSpan.className = config.unitClass;
		unitSpan.textContent = unit;

		// Vider l’élément et insérer la structure
		el.textContent = "";
		el.appendChild(valueSpan);
		if (unit) {
			el.appendChild(unitSpan);
		}
	};

	// Fonction d'animation
	const animate = (el, config) => {
		const startRaw = el.getAttribute(config.startAttr) || "0";
		const endRaw = el.getAttribute(config.endAttr) || "0";

		const startParsed = parseValue(startRaw);
		const endParsed = parseValue(endRaw);

		const unit = endParsed.unit || startParsed.unit;
		const start = startParsed.number;
		const end = endParsed.number;
		const duration = parseInt(el.getAttribute(config.durationAttr)) || 2000;

		const valueSpan = el.querySelector(`.${config.valueClass}`);
		const unitSpan = el.querySelector(`.${config.unitClass}`);

		if (unitSpan) unitSpan.textContent = unit;

		const lang = config.locale || document.documentElement.lang || "en-US";
		const formatter = new Intl.NumberFormat(lang, {
			minimumFractionDigits: config.decimals,
			maximumFractionDigits: config.decimals,
		});

		let startTimestamp = null;

		const step = (timestamp) => {
			if (!startTimestamp) startTimestamp = timestamp;
			const progress = Math.min((timestamp - startTimestamp) / duration, 1);
			const value = progress * (end - start) + start;

			valueSpan.textContent = formatter.format(value);

			if (progress < 1) {
				window.requestAnimationFrame(step);
			}
		};

		window.requestAnimationFrame(step);
	};

	// Initialisation
	const init = (userOptions = {}) => {
		const config = { ...defaults, ...userOptions };
		const elements = document.querySelectorAll(config.selector);

		if (!elements.length) return;

		elements.forEach((el) => prepareElement(el, config));

		const observer = new IntersectionObserver(
			(entries, obs) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						animate(entry.target, config);
						if (config.once) {
							obs.unobserve(entry.target);
						}
					}
				});
			},
			{ threshold: config.threshold }
		);

		elements.forEach((el) => observer.observe(el));
	};

	return { init };
})();

// USAGE
// CountUp.init({
//     selector: ".key-metric__number",
//     once: true,       // ou false si tu veux rejouer à chaque apparition
//     threshold: 0.3    // déclenche quand 30% est visible
// });
